module.exports = __webpack_public_path__ + "img/s1_img.218e73a0.png";